import instance from "../../utils/axios";

export const saveBulletinCoverImage = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val || ""));
  const response = await instance.post("/churches/bulletin/coverimage/save", formData);
  return response.data;
};

export const updateBulletinCoverImage = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val || ""));
  const response = await instance.post("/churches/bulletin/coverimage/update", formData);
  return response.data;
};
export const deleteBulletinCoverImageApi = async (payload) => {

  // Extract payload (in case it's nested under apiPayloadRequest)
  const data = payload?.apiPayloadRequest || payload;

  // Validate required fields
  const required = ["_id", "bulletinObjId", "bullitenimageObjId"];
  required.forEach((key) => {
    if (!data[key]) throw new Error(`Missing field: ${key}`);
  });

  // Prepare form data
  const formData = new URLSearchParams();
  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value ?? "");
  });

  // Make API call
  const response = await instance.post(`/churches/bulletin/coverimage/delete`, formData);
  return response.data; // Expected: { type, message, data }
};